import React from 'react';
import { Link } from 'react-router-dom';

// project-imports
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';

const BreadcrumbOne = ({ title, rootUrl, parentUrl, currentUrl, googleEnum, extraClass = "" }) => {

    return (
        <div className="edu-breadcrumb-area breadcrumb-style-1 ptb--16 bg-image">
            <div className={`container ${extraClass ? extraClass : ""} eduvibe-animated-shape`}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="breadcrumb-inner text-start">
                            {/* <div className="page-title">
                                <h3 className="title text-capitalize" dangerouslySetInnerHTML={{ __html: title }}></h3>
                            </div> */}
                            <nav className="edu-breadcrumb-nav">
                                <ol className="edu-breadcrumb d-flex justify-content-start liststyle ">
                                    <li className="breadcrumb-item fs-5">
                                        <Link
                                            /* Google analytics impliment Start By Roshan  */
                                            onClick={() => triggerFunction(GoogleAnalyticsEnum.LINK, googleEnum)}
                                            /* Google analytics impliment End By Roshan  */
                                            to={`${rootUrl}`}
                                            dangerouslySetInnerHTML={{ __html: parentUrl }}>
                                        </Link></li>
                                    <li className="separator fs-5"><i className="ri-arrow-drop-right-line"></i></li>
                                    <li className="breadcrumb-item active fs-5" dangerouslySetInnerHTML={{ __html: currentUrl }}></li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                {/* Modified by Longswitch Team added xxl for that nest hub max scroll issue  */}
                {/* <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-11-07.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-01-02.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-3">
                        <img src="/images/shapes/shape-03.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-4">
                        <img src="/images/shapes/shape-13-12.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-5">
                        <img src="/images/shapes/shape-36.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-6">
                        <img src="/images/shapes/shape-05-07.png" alt="Shape Thumb" />
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default BreadcrumbOne;